<template>
  <OrganMgrSyncToWechat />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
